/**
 * Fit & Feel accordions (sections/fit-and-feel-metafields.liquid).
 *
 * Loaded on every product page from snippets/scripts.liquid rather than from the section itself.
 * Choosing another Absorbency or pack (combined listing) swaps the new product's page content in
 * without a reload, and scripts inside swapped-in HTML never run. Listening once on `document`
 * means headers that arrive later work too, including when the first page had no Fit & Feel
 * section (e.g. the pad kit on the default product template).
 */

/**
 * @param {EventTarget | null} target
 * @returns {{ toggle: Element, panel: Element } | null}
 */
function getParts(target) {
  if (!(target instanceof Element)) return null;
  const toggle = target.closest('[data-toggle]');
  const accordion = toggle?.closest('[data-accordion][class*="ff-accordion-"]');
  const panel = accordion?.querySelector('[data-panel]');
  if (!toggle || !panel) return null;
  return { toggle, panel };
}

/** @param {{ toggle: Element, panel: Element }} parts */
function toggleAccordion({ toggle, panel }) {
  const isOpen = !panel.classList.contains('active');
  panel.classList.toggle('active', isOpen);
  toggle.setAttribute('data-open', String(isOpen));
  toggle.setAttribute('aria-expanded', String(isOpen));
}

document.addEventListener('click', (event) => {
  const parts = getParts(event.target);
  if (parts) toggleAccordion(parts);
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter' && event.key !== ' ') return;
  const parts = getParts(event.target);
  if (!parts) return;
  event.preventDefault();
  toggleAccordion(parts);
});
